<template>
    <div>
        <div class="p-layout-breadcrumb">
            <el-row type="flex" align="middle">
                <el-col :span="3">
                    <h3>订单发货管理</h3>
                </el-col>
            </el-row>
        </div>


        <el-table :data="fetchList" v-loading="loading" element-loading-text="拼命加载中">
            <el-table-column prop="orderNo" label="订单编号">
            </el-table-column>
            <el-table-column inline-template :context="_self" label="用户名">
                <span v-if="row.userManage">{{row.userManage.nickName}}</span>
            </el-table-column>
            <el-table-column prop="rentDay" label="租赁天数">
            </el-table-column>
            <el-table-column prop="dispalyExtra.paidData.rental" label="租金金额">
            </el-table-column>
            <el-table-column inline-template :context="_self" label="支付方式">
                <span>{{ row.isAlipayMini ? '支付宝支付' : '微信支付'}}</span>
            </el-table-column>
            <el-table-column inline-template :context="_self" label="订单状态">
                <div>
                    <span v-if="row.status === 0">待付款</span>
                    <span v-if="row.status === 1">待发货</span>
                    <span v-if="row.status === 2">交易关闭</span>
                    <span v-if="row.status === 3">待收货</span>
                    <span v-if="row.status === 4">待返还</span>
                    <span v-if="row.status === 5">待返还</span>
                    <span v-if="row.status === 6">待返还确认</span>
                    <span v-if="row.status === 7">已完成</span>
                    <span v-if="row.status === 8">退款中</span>
                    <span v-if="row.status === 9">已退款</span>
                    <span v-if="row.status === 98">已预约顺丰</span>
                    <span v-if="row.status === 99">完成中</span>
                    <span v-if="row.status === 100">已删除</span>
                </div>
            </el-table-column>
            <el-table-column inline-template :context="_self" label="下单时间">
                <span>{{ new Date(row.created).getFullYear()+'-'+(new Date(row.created).getMonth()+1)+'-'+new Date(row.created).getDate()+' '+new Date(row.created).getHours()+':'+new Date(row.created).getMinutes()+':'+new Date(row.created).getSeconds()}} </span>
            </el-table-column>
            <el-table-column inline-template :context="_self" label="操作">
                <span>
                                        <el-button @click="handleSend($index, row)" type="text" size="small">发货</el-button>
                                    </span>
            </el-table-column>
        </el-table>

        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="20" layout="total, prev, pager, next" :total="totalNum">
        </el-pagination>

    </div>
</template>

<script>
    import {
        getOrder,
        getOrderCount
    } from '../../api/version'

    export default {
        data() {
            return {
                fetchList: [],
                currentPage: 1,
                totalNum: 0,
                loading: true
            }
        },

        created() {
            let filter = JSON.stringify({
                "limit": 20,
                "skip": 0,
                "order": "id desc",
                'include': 'userManage',
                'where': {
                    status: 1
                }
            })
            getOrder(sessionStorage.userId, filter).then(res => {
                this.fetchList = res.data
                this.totalCount = res.data.length

                this.loading = false
                this.fetchList.forEach((item, index) => {
                    console.log(item)
                    this.loading = false
                    let day = parseInt((new Date(item.dispalyExtra.tenancy[0].end) - new Date(item.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24))
                    this.fetchList[index].rentDay = day === 0 ? '1' : day+1
                })
            })
            getOrderCount(sessionStorage.userId, JSON.stringify({
                    'status': 1
                })).then(res => {
                console.log(res.data)
                this.totalNum = res.data.count
            })

        },

        methods: {
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.loading = true
                let filter = JSON.stringify({
                    "limit": 20,
                    "skip": 20 * (--val),
                    "order": "id desc",
                    'include': 'userManage',
                    'where': {
                        status: 1
                    }
                })
                getOrder(sessionStorage.userId, filter).then(res => {
                    this.fetchList = res.data
                    this.totalCount = res.data.length
                    this.loading = false
                    this.fetchList.forEach((item, index) => {
                        console.log(item)
                        let day = parseInt((new Date(item.dispalyExtra.tenancy[0].end) - new Date(item.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24))
                        this.fetchList[index].rentDay = day === 0 ? '1' : day+1
                    })
                })
            },
            handleSend(index, row) {
                this.$router.push('/sendExpress/' + row.id)
            },
            selectionChange: function(selections) {
                this.$emit("selectionChange", selections);
            },
            Search() {

            },
            startChange(val) {
                console.log(val)
                this.pickerOptionsEnd = {
                    disabledDate(time) {
                        return time.getTime() < new Date(val).getTime();
                    }
                }
            },
            endChange(val) {
                console.log(val)
                this.pickerOptionsStart = {
                    disabledDate(time) {
                        return time.getTime() > new Date(val).getTime();
                    }
                }
            }
        }
    }
</script>

<style>
    .user-pic {
        width: 50px;
        height: 50px;
        margin-top: 10px;
    }

    .avatar-uploader .el-upload {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .page-footer {
        margin-top: 60px;
        text-align: center;
    }

    .el-pagination {
        text-align: right;
        margin-top: 20px;
    }
</style>



// WEBPACK FOOTER //
// OrderExpress.vue?70624103